module.exports = __webpack_public_path__ + "img/cemuk.66b4b5fd.png";